import(/* webpackMode: "eager", webpackExports: ["I18nProviderClient"] */ "/home/runner/work/product-frontend/product-frontend/locales/client.ts");
